import { create } from "zustand";
import { languageConstants } from "main/src/js/constants/internationalize";
import { updateSelectedLanguageService } from "main/src/js/services/internationalize";
import Godaam from "main/src/js/utils/storage";

type LanguageState = {
  language: string;
  loading: boolean;
  error: string | null;
  setLanguage: (language: string) => void;
  updateUserLanguage: (language: string) => Promise<void>;
  reset: () => void;
};

const initialState = {
  language:
    (Godaam.preferredLanguage as string) || languageConstants.DEFAULT_LOCALE,
  loading: false,
  error: null
};

export const useLanguageStore = create<LanguageState>()((set, get) => ({
  ...initialState,

  setLanguage: (language: string) => {
    Godaam.preferredLanguage = language;
    set({ language });
  },

  updateUserLanguage: async (language: string) => {
    set({ loading: true, error: null });

    try {
      await updateSelectedLanguageService.updateSelectedLanguage(language);
      get().setLanguage(language);
      set({ loading: false });
      window.location.reload();
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to update language";
      set({ loading: false, error: errorMessage });
      get().setLanguage(language);
      window.location.reload();
    }
  },

  reset: () => {
    set(initialState);
  }
}));
